import { memo } from 'react';

import { TranslateString } from '@/types/translation.types';
import { updateTranslateKey } from '@/utils/update-translation-key';
import TextArea from '@ui/text-area/text-area';

type TEditBioProps = {
  description: TranslateString | undefined;
  onChange: (value: TranslateString) => void;
  baseLanguage: string;
  language: string;
};

const EditBio = memo(({ description, onChange, baseLanguage, language }: TEditBioProps) => {
  return (
    <label htmlFor="bio" className="flex-column gap-4">
      <TextArea
        label="Bio"
        id="bio"
        rows={3}
        minRows={3}
        placeholder="Add bio"
        value={description?.base || ''}
        style={{ padding: '12px 16px' }}
        onChange={(e) =>
          onChange(
            updateTranslateKey({
              translateString: description ?? { base: '', changed: '' },
              input: e.target.value,
              baseLanguage,
              language,
            })
          )
        }
      />
    </label>
  );
});

EditBio.displayName = 'EditBio';

export default EditBio;
